import { Cookies } from 'react-cookie';

import { CombinedSRBMChartData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getCombinedSRBMChartData = async (slug: string, isPercents: boolean) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/srbm/combined-chart-data/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      isPercents,
    },
  });
  return data.data as CombinedSRBMChartData[];
};
